import { render, staticRenderFns } from "./PlatformSelection.vue?vue&type=template&id=28a09324"
import script from "./PlatformSelection.vue?vue&type=script&lang=ts"
export * from "./PlatformSelection.vue?vue&type=script&lang=ts"
import style0 from "./PlatformSelection.vue?vue&type=style&index=0&id=28a09324&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports